var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AuthPage',{attrs:{"page":_vm.page}},[_c('LoginForm',{on:{"login":_vm.handleContinue,"goToRegister":_vm.goToRegister}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }